<template>
  <div>
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>TBA</b> /

      <router-link to="/tba/feedback">
        Feedback
      </router-link>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-12">

        <div class="card mb-4">
          <template v-if="headers.length !== 0">
            <div class="card mx-4 p-4" style="margin-bottom: 20px; margin-top: 20px;">
              <div class="" style="display: flex; align-items: center; margin-left: 20px; margin-bottom: 10px;"
                v-for="(header, index) in headers" :key="header.id">
                <span>{{ index + 1 }}. {{ header.question }}</span>
              </div>
            </div>

          </template>
          <div class="mt-4 ml-4">
            <div class="d-flex flex-row">
              <div class="mr-2">
                <label for="dateFrom">From</label>
                <input type="month" class="form-control" id="dateFrom" v-model="dateFrom" :min="'2025-01'" />
              </div>
              <div class="mr-2">
                <label for="dateTo">To</label>
                <input type="month" class="form-control" id="dateTo" v-model="dateTo" :min="'2025-01'" />
              </div>
              <div class="d-flex align-items-end">
                <button class="btn btn-primary rounded ml-2" @click="handleFilter()">
                  Filter
                </button>
              </div>
            </div>
          </div>
          <div class="card mx-4 mt-4 p-4 d-flex justify-content-center" style="width: 500px;">
            <div class="text-center ">
              <h3><b>{{ statistic.title }}</b></h3>
              <p>{{ statistic.subtitle }}</p>
            </div>
            <div class="d-flex justify-content-center">
              <GChart v-if="statistic.columnData && statistic.columnData.length" type="ColumnChart"
                :data="statistic.columnData" :options="statistic.columnOptions" />
              <p v-else class="text-center">No statistics available for this period</p>

            </div>
          </div>

          <div class="p-4">
            <h3><b>List of Feedback</b></h3>
            <p>The table below shows the list of feedback.</p>
          </div>

          <div class="mb-3" style="padding: 0 20px;">
            <table table id="feedback_tbl" class="display table table-striped table-bordered"
              style="width: 100%; text-align: center">
              <thead>
                <tr>
                  <th style="width: 5%">No.</th>
                  <th style="width: 30%;">Customer Name</th>
                  <th style="width: 10%;" v-for="(question, index) in headers" :key="question.id">{{ index + 1 }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(feedback, index) in rows" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ feedback.user }}</td>
                  <td v-for="answer in feedback.answers" :key="answer.id">{{
                    answer }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";
import {
  getFeedback,
  getFeedbackStatistic
} from "../../services/FeedbackService";

export default {
  components: {
    GChart
  },
  data() {
    return {
      years: [2024, 2023, 2022, 2021, 2020],
      statistic: {

        chartOptions: {
          chart: {
            title: 'Company Performance',
            subtitle: 'Sales, Expenses, and Profit: 2014-2017',
          }
        }
      },
      very_satisfied: 0,
      satisfied: 0,
      neutral: 0,
      dissatisfied: 0,
      very_dissatisfied: 0,
      yearFilter: new Date().getFullYear(),
      columnData: [],
      ratings: [],
      counts: [],
      feedbacks: [],
      headers: [],
      rows: [],
      columnData: [],
      columnOptions: {},
      meta: {
        current_page: 1,
        last_page: 1,
        links: [],
      },
      dateTo: '2025-12',
      dateFrom: '2025-01'
    };
  },
  methods: {
    destroyDatatable() {
      if ($.fn.DataTable.isDataTable("#feedback_tbl")) {
        $("#feedback_tbl").DataTable().destroy();
      }
    },
    async fetchFeedback() {
      try {
        if (this.rows.length) {
          this.destroyDatatable();
        }
        this.feedbacks = [];
        const request = {
          "date_from": this.dateFrom,
          "date_to": this.dateTo
        }
        const response = await getFeedback(request);
        if (response.data.success) {
          this.headers = response.data.data.headers;
          this.rows = response.data.data.rows;
          this.$nextTick(() => {
            this.setDatatable();
          });
        }
      } catch (error) {
        console.error(error);
      }
    },

    async fetchFeedbackStatistic() {
      try {
        const request = {
          "date_from": this.dateFrom,
          "date_to": this.dateTo
        }
        const response = await getFeedbackStatistic(request);
        if (response.data.success) {
          this.statistic = response.data.data;
          if (response.data.data === null) {
            this.statistic.columnData = [];
            this.statistic.columnOptions = {};
          }
        }
      } catch (error) {
        console.error("Error fetching feedback statistics:", error);
      }
    },

    handleFilter() {
      this.fetchFeedback(),
        this.fetchFeedbackStatistic()
    },

    setDatatable() {
      $("#feedback_tbl").DataTable({
        pageLength: 10,
        dom: "Bfrtip",
        buttons: ["excel", "pdf"]
      });
    }
  },

  async mounted() {
    await this.fetchFeedback();
    await this.fetchFeedbackStatistic();
  }
};
</script>

<style>
.star-icon {
  color: gold;
}
</style>
